import React from 'react';
const links = ['Termini di Servizio', 'Privacy Policy', 'Contatti'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-94" data-mp="3gfiyctkyyvje">
      <div className="mx-auto max-w-5xl text-center" data-id="element-95" data-mp="3gh3qydnq44em">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-96" data-mp="32ovz90bar3ms">
          AZIENDALE PRONTA™
        </p>
        <nav aria-label="Footer" data-id="element-97" data-mp="36ppnjusnikg7">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-98" data-mp="3ufa5cad2jbnw">
            {links.map(link => <li key={link} data-id="element-99" data-mp="37xv6falryhh">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-100" data-mp="3lem1g8he2roq">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-101" data-mp="29zgnu9fpz8qc">
          © 2026 AZIENDALE PRONTA™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}